// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCloudSlash = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.0502 36.9497C31.6345 41.7183 35.2163 45.5089 37.9987 48.4908C39.2822 49.8663 38.5487 51.719 36.6717 51.8465C35.1768 51.948 33.619 51.9999 32 51.9999C14.4788 51.9999 4 46.0121 4 35.9999C4 30.4369 8.54615 25.9448 14.1233 26.0081C15.1857 26.0201 15.892 26.3578 16.6674 27.0842C19.4561 29.6968 22.8792 32.94 27.0502 36.9497ZM60.0001 36C60.0001 31.757 57.3531 28.1402 53.6241 26.6876C53.8628 25.8312 54.0001 24.9324 54.0001 23.9999C54.0001 18.4771 49.5229 14 44.0001 14C41.5954 14 39.3898 14.85 37.6648 16.2644C35.157 12.4903 30.871 10 26 10C22.9728 10 20.1844 10.9789 17.8953 12.6132C15.6849 10.1815 14.6566 8.99958 14.3114 8.65449C13.4388 7.78181 12.3556 7.78187 11.483 8.65449L8.65457 11.4829C7.78196 12.3555 7.78189 13.4387 8.65457 14.3113C9.45743 15.1141 14.7687 19.5953 29.8788 34.1213C44.4048 49.2314 48.8859 54.5427 49.6888 55.3455C50.5614 56.2181 51.6446 56.2181 52.5172 55.3455L55.3456 52.5171C56.2182 51.6445 56.2183 50.5613 55.3456 49.6887C55.0847 49.4277 54.3434 48.7743 52.9486 47.518C57.5109 44.7793 60.0001 40.8688 60.0001 36Z" />
    </svg>
  );
};
